<template>
  <div class="load-more">
    <button v-if="!isLoading" :class="buttonClass" class="btn w-full" type="button">
      <slot>{{ $t('common.load_more') }}</slot>
    </button>
    <LoadingSpinner v-else />
  </div>
</template>

<script>
import { LoadingSpinner } from 'vue_features/shared/components/ui'

export default {
  name: 'LoadMoreButton',
  components: { LoadingSpinner },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    buttonClass: {
      type: String,
      default: '',
    },
  },
}
</script>
